import PropTypes from 'prop-types';
import React from 'react';

import AspectRatio from 'components/AspectRatio';
import Image from 'components/ImageV2';
import { IMAGE_BG_COLOR, IMAGE_RATIOS, IMAGE_WIDTHS } from 'constants/images';
import Theme from 'styles/theme';

const UpsellImage = ({ src, alt, href }) => (
  <a className="UpsellImage" href={href}>
    <AspectRatio className="UpsellImage__aspect-ratio" width={1} height={1}>
      <Image
        src={src}
        alt={alt}
        className="UpsellImage__image"
        width={IMAGE_WIDTHS.W_150}
        ratio={IMAGE_RATIOS.R_1x1}
        transformations={{ backgroundColor: IMAGE_BG_COLOR }}
      />
    </AspectRatio>

    <style jsx>
      {`
        .UpsellImage {
          margin-right: ${Theme.get('spacing') * 3}px;
        }
      `}
    </style>
    <style jsx global>
      {`
        .AspectRatio.UpsellImage__aspect-ratio {
          width: ${IMAGE_WIDTHS.W_70}px;
          height: ${IMAGE_WIDTHS.W_70}px;
        }
      `}
    </style>
  </a>
);

UpsellImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  href: PropTypes.string.isRequired,
};

UpsellImage.defaultProps = { alt: '' };

export default UpsellImage;
